import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import { RouterProvider } from 'react-router';
import { Router } from '@/routing/Router';
import '@/core/runtime';

createRoot(document.getElementById('root')!).render(<RouterProvider router={Router} />);

if (import.meta.hot) {
  import.meta.hot.accept();
}

export {};
